import { ShoppingListModel } from '../../../../types/ShoppingList';
import { ShoppingListProductModel } from '../../../../types/ShoppingListProduct';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareDeleteShoppingList = ({
    shoppingListElement,
}: {
    shoppingListElement: ShoppingListModel;
}) => shoppingListElement.prepareMarkAsDeleted();

export const logDeleteShoppingListActions = ({
    shoppingListElement,
    productsToDelete,
    logDBAction,
    tableName,
}: {
    shoppingListElement: ShoppingListModel;
    productsToDelete: ShoppingListProductModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Delete shopping list',
        modelName: tableName,
        payload: shoppingListElement,
    });

    if (productsToDelete.length > 0) {
        logDBAction({
            message: 'Delete shopping list - delete shopping list products',
            modelName: tableName,
            payload: productsToDelete,
        });
    }
};
